export default "__VITE_ASSET__DV2H_LtN__"